<div class="span-12-9-9 col">
  <p-panel [header]="'Addresses_Title' | translateWF: 'Address'">
    @if (!viewOnly) {
      <ng-template pTemplate="icons">
        <p-button [label]="'Add' | translateWF: 'Add'" variant="outlined" icon="pi pi-plus" (click)="openModalAddress(null)" />
      </ng-template>
    }
    <p-card data-variant="compact">
      <p-table
        [value]="addresses"
        [paginator]="true"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
        [rowHover]="true"
        selectionMode="single"
        [customSort]="true"
        (sortFunction)="onTableSort($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="code">
              {{ 'Addresses_Code' | translateWF: 'Code' }}
              <p-sortIcon field="code"></p-sortIcon>
            </th>
            <th pSortableColumn="country">
              {{ 'Addresses_Country' | translateWF: 'Country' }}
              <p-sortIcon field="country"></p-sortIcon>
            </th>
            @if (!viewOnly) {
              <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-address>
          <tr>
            <td>{{ address.code }}</td>
            <td>{{ address.country }}</td>
            @if (!viewOnly) {
              <td>
                <p-button type="button" icon="pi pi-pencil" (click)="openModalAddress(address)" />
              </td>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="viewOnly ? 2 : 3" class="text-center">
              {{ 'General_NoRecords' | translateWF: 'No records found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </p-panel>
</div>
